<template>
  <div>
    <b-card class="cardItem">
      <b-row class="justify-content-center">
        <b-col>
          <div class="itemTitle">
            <div class="termText">취소 규정</div>
            <!--            <div class="detailButton">-->
            <!--              <b-button v-b-toggle href="#reserve-detail-3" variant="primary" @click.prevent>상세 보기</b-button>-->
            <!--            </div>-->
          </div>
        </b-col>
      </b-row>
      <!--      <b-collapse class="justify-content-center" id="reserve-detail-3">-->
      <hr />
      <div class="mt-3">
        <ol>
          <li>
            <p>단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다. (프로그램 별 페이지에서 확인 가능)</p>
          </li>
          <li><p>천재지변 및 업체의 운영상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.</p></li>
        </ol>
      </div>
      <hr />
      <div class="checkBoxContainer">
        <b-checkbox v-model="termsInfo.agreeCancel" @change="checkAgreeSingle">위 내용에 동의합니다.</b-checkbox>
      </div>
      <!--      </b-collapse>-->
    </b-card>
    <b-card class="cardItem">
      <b-row class="justify-content-center">
        <b-col>
          <div class="itemTitle">
            <div class="termText">개인정보 수집 및 이용 동의서</div>
            <div class="detailButton">
              <b-button v-b-toggle href="#reserve-detail-4" variant="primary" @click.prevent>상세 보기</b-button>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-collapse class="justify-content-center" id="reserve-detail-4">
        <hr />
        <div class="mt-3">
          <div class="subText">
            <p>SK핀크스㈜에서 운영하는 홈페이지를 통하여 적법하고 공정한 수단에 의하여</p>
            <p>고객님의 개인정보를 수집합니다.</p>
          </div>
          <b-table-simple>
            <b-thead>
              <b-tr>
                <b-th>필수항목</b-th>
                <b-th>수집 및 이용목적</b-th>
                <b-th>보유기간</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td>성명, 연락처, 이메일</b-td>
                <b-td>- 본인 확인 절차에 활용 - 사전 결제 내용 확인 수단 - 예약 사항 고지 수단</b-td>
                <b-td
                  >12개월 - 예약 완료 고객의 경우 이용일자 기준 - 예약 취소 고객의 경우 예약신청 일자 기준 5일 후</b-td
                >
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <div class="subText">
            <p>필수항목에 대한 수집 및 이용에 동의 하지 않을 권리는 있으나,</p>
            <p>미동의 시 서비스를 이용하실 수 없습니다.</p>
          </div>
          <hr />
          <div class="checkBoxContainer">
            <b-checkbox v-model="termsInfo.agreePersonalCollect" @change="checkAgreeSingle">
              위 내용에 동의합니다.
            </b-checkbox>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card class="cardItem">
      <b-row class="justify-content-center">
        <b-col>
          <div class="itemTitle">
            <div class="termText">개인정보 처리위탁 동의서</div>
            <div class="detailButton">
              <b-button v-b-toggle href="#reserve-detail-5" variant="primary" @click.prevent>상세 보기</b-button>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-collapse class="justify-content-center" id="reserve-detail-5">
        <div class="mt-3">
          <hr />
          <b-table-simple>
            <b-thead>
              <b-tr>
                <b-th style="width: 30%">수탁자명</b-th>
                <b-th>처리위탁업무</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td>SK 네트웍스서비스㈜</b-td>
                <b-td>서버 네트워킹 서비스, 홈페이지 운영 관리 및 논리적 및 물리적 데이터 베이스 관리</b-td>
              </b-tr>
              <b-tr>
                <b-td>비즈톡 주식회사</b-td>
                <b-td>문자발송(SMS) 서비스</b-td>
              </b-tr>
              <b-tr>
                <b-td>SCI 평가정보㈜</b-td>
                <b-td>아이핀/휴대폰을 통한 본인인증</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <div class="subText">
            <p>처리위탁에 동의하지 않을 권리는 있으나, 미동의 시 서비스를 이용하실 수 없습니다.</p>
          </div>
        </div>
        <hr />
        <div class="checkBoxContainer">
          <b-checkbox v-model="termsInfo.agreePersonalGive" @change="checkAgreeSingle"
            >개인정보의 처리위탁에 동의합니다.
          </b-checkbox>
        </div>
      </b-collapse>
    </b-card>
    <div class="checkBoxContainer">
      <b-checkbox v-model="termsInfo.agreeAll" @change="checkAgreeAll"><b>위 규정에 모두 동의합니다.</b></b-checkbox>
    </div>
    <div class="endRowSpace"></div>
  </div>
</template>

<script>
import moment from 'moment';
import {DateUtil} from '@/util/DateUtil';

export default {
  name: 'TermsInfoInput',
  props: {
    termsInfo: Object,
  },
  filters: {
    YYYYMMDD(str) {
      return DateUtil.getYYYY_MM_DD_WEEK(moment(str).toDate());
    },
    PRICE(price) {
      return new Intl.NumberFormat().format(price);
    },
  },
  data() {
    return {};
  },
  methods: {
    checkAgreeSingle() {
      console.log();
    },
    checkAgreeAll() {
      console.log();
      this.termsInfo.agreeCancel = this.termsInfo.agreeAll;
      this.termsInfo.agreePersonalCollect = this.termsInfo.agreeAll;
      this.termsInfo.agreePersonalGive = this.termsInfo.agreeAll;
    },
  },
};
</script>

<style scoped lang="scss">
p {
  font-size: 0.8rem;
  margin-bottom: 0rem;
}
th {
  font-size: 0.8rem !important;
  font-weight: 800;
  background-color: #f1f1f1;
}
td {
  font-size: 0.8rem !important;
  color: #767676;
}
.topHeader {
  display: flex;
  padding-top: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-weight: bold;
  font-size: 1.3rem;
}
.cardItem {
  display: flex;
  border: 1px solid #cfcfcf;
  margin: 1rem;
}
.itemTitle {
  display: flex;
  width: 100%;
  line-height: 2rem;
  font-size: 1.1rem;
}
.termText {
  width: 70%;
  font-weight: 600;
  line-height: 2.3rem;
}
.detailButton {
  width: 30%;
  text-align: right;
}
.row {
  display: flex;

  line-height: 3rem;
}

.rowHeader {
  flex: 1;
  text-align: left;
  line-height: 2.6rem;
  font-weight: bold;
}
.rowContent {
  flex: 5;
  line-height: 2.6rem;
}

.colSpace {
  width: 0.3rem;
  border: 0px;
}
.rowCardContent {
  flex: 5;
  display: flex;
  line-height: 2.6rem;
}
.checkBoxContainer {
  text-align: center;
}
.subText {
  text-align: center;
  margin-bottom: 1rem;
}
.endRowSpace {
  height: 3rem;
}

@media (max-width: 992px) {
  .cardItem {
    display: flex;
    border: 1px solid #cfcfcf;
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 0rem;
    margin-right: 0rem;
  }
  li {
  }
}
</style>
